import "@Styles/Shared/RelatedContent/relatedContent_sm.less";
import "@Styles/Shared/RelatedContent/PB/relatedContent_sm.less";
import "@Styles/Shared/RelatedContent/relatedContent_md.less";
import "@Styles/Shared/RelatedContent/relatedContent_lg.less";
import { LazyLoadImages } from '@Shared/Common';
export default {
  data: function data() {
    return {
      isItemFavorite: {},
      config: {},
      cookieName: ""
    };
  },
  methods: {
    //#region Public methods
    // This function runs when the component loads
    init: function init(config) {
      this.config = config;
      this.cookieName = 'relatedContentFavorite_initialState_' + this.config.dataSourceId; // Try to load any cookies if we've been directed back to this page, post-login

      var cookieData = this.getCookieData(this.cookieName); // If we found the cookie, toggle the favorite

      if (typeof cookieData !== 'undefined') {
        var cookieObject = JSON.parse(cookieData);
        this.toggleFavorite(cookieObject.contentId, cookieObject.contentType, cookieObject.title, 'False'); // Delete the cookie now what we're done

        this.deleteCookie();
      } // Set the initial favorite values


      this.setFavorites();
    },
    // This method handles when the content's name or thumbnail is clicked
    itemClick: function itemClick(event) {
      event.stopPropagation();
      var item = event.currentTarget;
      var data = this.getItemData(item);
      this.raiseViewEvent(data, "ContentResult");
    },
    // This method will toggle a favorite on and off
    toggleFavorite: function toggleFavorite(contentId, contentType, title) {
      if (!contentId || !contentType || !title) return; // Toggle the favorite if the user is logged in, otherwise make them log in

      if (!this.config.isCurrentUserAnonymous && !this.config.isAnonymousUserWithFavorites) {
        this.performFavoriteToggle(contentId, contentType, title);
      } else {
        this.setCookie(this.config.dataSourceId, contentId, contentType, title);
        this.openRegistration(this.config.relatedContentList.listSettings);
      }
    },
    //#endregion
    //#region Private methods
    // This method handles the formulation and return of a nice item "object"
    getItemData: function getItemData(item) {
      var data = {};

      if (item) {
        data = {
          contentId: item.getAttribute('data-contentid') || '',
          contentType: item.getAttribute('data-contenttype') || '',
          title: item.getAttribute('data-title') || ''
        };
      }

      return data;
    },
    // This method will do the groundwork for toggling a favorite on and off
    performFavoriteToggle: function performFavoriteToggle(contentId, contentType, title) {
      var isFavorite = false; // Try to find the item, return if we didn't

      var itemIndex = this.config.relatedContentList.items.findIndex(function (element) {
        return element.contentId === contentId;
      });
      if (itemIndex === -1) return; // We found the item, let's determine its new status

      isFavorite = !this.config.relatedContentList.items[itemIndex].isFavorite; // Formulate the target service URL

      var url = isFavorite ? '/api/relatedContentFavorite/add/' : '/api/relatedContentFavorite/remove/'; // Prepare for the POST

      var postOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      }; // Define the callback function for toggling of the favorites

      var callback = function callback(webResponse, context) {
        if (webResponse) {
          // Raise an analytics event if the request succeeded
          if (isFavorite) {
            var data = {};
            data = {
              contentId: contentId,
              contentType: contentType,
              title: title
            };
            context.raiseViewEvent(data, "AddToFavorites");
          } // Adjust the item's status


          context.config.relatedContentList.items[itemIndex].isFavorite = isFavorite; // Set the item status for favorite styling

          context.$set(context.isItemFavorite, contentId, isFavorite);
        }
      }; // Make the call to toggle the favorite


      this.makeWebRequest(url + contentId, postOptions, callback);
    },
    // This method makes a web request and returns whether it was successful
    makeWebRequest: function makeWebRequest(url, postOptions, callback) {
      var _this = this;

      fetch(url, postOptions).then(function (response) {
        callback(response.status === 200 || response.status === 204, _this);
      });
    },
    // This method sets the favorite status for each item
    setFavorites: function setFavorites() {
      var _this2 = this;

      this.config.relatedContentList.items.forEach(function (item) {
        _this2.$set(_this2.isItemFavorite, item.contentId, item.isFavorite);
      });
    },
    // This helper method will get the cookie data
    getCookieData: function getCookieData() {
      var name = this.cookieName + "=";
      var decodedCookies = decodeURIComponent(document.cookie);
      var allCookiesArray = decodedCookies.split('; ');
      var contents; // Loop through all of the cookies and look for the target one

      allCookiesArray.forEach(function (value) {
        if (value.indexOf(name) === 0) contents = value.substring(name.length);
      }); // If we found the cookie return its contents, deserialized back into an object

      return contents;
    },
    // This helper method will set the cookie data
    setCookie: function setCookie(dataSourceId, contentId, contentType, title) {
      if (!contentId || !contentType || !title || !dataSourceId) return; // Define the cookie data, id will be the content list's id, since the user can only click and redirect / login, having attempted to save one item per time

      var cookieData = {
        contentId: contentId,
        contentType: contentType,
        title: title
      }; // Set the cookie

      var cookieContents = this.cookieName + "=" + JSON.stringify(cookieData);
      document.cookie = cookieContents;
    },
    // This helper method will delete the cookie
    deleteCookie: function deleteCookie() {
      document.cookie = this.cookieName + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    },
    // This method sends the user to the login / registration form
    openRegistration: function openRegistration(listSettings) {
      var url = listSettings.fullPageRegistrationUrl || '/user-profile/login';
      url += '?isRegistrationFirstStep=false&returnUrl=' + encodeURIComponent(window.location.href);
      if (listSettings.regAction) url += '&regAction=' + listSettings.regAction;
      if (listSettings.eSrcCode) url += '&eSrcCode=' + listSettings.eSrcCode;
      if (this.config.isAnonymousUserWithFavorites) url += '&value_prop=AnonFavorites'; // Redirect to the full page registration

      window.location.href = url;
    },
    // This helper method will Pascal-case a string
    toPascalCase: function toPascalCase(stringToModify) {
      return stringToModify == null ? null : stringToModify.replace(/(\w)(\w*)/g, function (g0, g1, g2) {
        return g1.toUpperCase() + g2.toLowerCase();
      });
    },
    // This method raises an analytics event
    raiseViewEvent: function raiseViewEvent(data, eventType) {
      if (!data.contentId || !data.contentType || !data.title) return;
      var event = {
        EventType: eventType,
        ContentListName: 'RelatedContent',
        TemplateName: 'RelatedContent',
        ContentId: data.contentId,
        ContentTitle: data.title,
        ContentType: this.toPascalCase(data.contentType),
        RecordType: this.toPascalCase(data.contentType)
      };
      if (GeneralMills.Analytics) GeneralMills.Analytics.raiseEvent(event);
    } //#endregion

  },
  directives: {
    lazyloadimages: LazyLoadImages
  }
};